import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiCalendar,
  FiCheckSquare,
  FiClipboard,
  FiFileText,
  FiGrid,
  FiLogOut,
  FiSettings,
  FiUsers
} = FiIcons;

const links = [
  ['dashboard', 'Today', FiGrid],
  ['events', 'Events', FiCalendar],
  ['submissions', 'Client Answers', FiCheckSquare],
  ['questionnaires', 'Questionnaires', FiClipboard],
  ['settings', 'Settings', FiSettings]
];

function countThisMonth(events = []) {
  const now = new Date();
  return events.filter((event) => {
    const match = String(event.date || '').match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (!match) return false;
    return Number(match[1]) === now.getFullYear() &&
      Number(match[2]) - 1 === now.getMonth();
  }).length;
}

const cardStyle = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  margin: '16px 0 0',
  padding: '12px 14px',
  background: '#24344F',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 12,
  color: '#F1F1F1',
  font: 'inherit',
  fontWeight: 600,
  cursor: 'pointer',
  boxShadow: 'none'
};

function AdminSidebar({ page, setPage, open, events, onOpenMonth, onLogOut }) {
  const activePage = page === 'builder' || page === 'templates'
    ? 'questionnaires'
    : page;
  const monthCount = countThisMonth(events);

  return (
    <aside className={`sidebar ${open ? 'open' : ''}`}>
      <span className="sidebar-label">Workspace</span>
      <nav>
        {links.map(([id, label, icon]) => (
          <button
            type="button"
            key={id}
            className={activePage === id ? 'active' : ''}
            onClick={() => setPage(id)}
          >
            <SafeIcon icon={icon} />
            {label}
          </button>
        ))}
        <button
          type="button"
          className="sidebar-logout"
          onClick={onLogOut}
        >
          <SafeIcon icon={FiLogOut} />
          Log out
        </button>
      </nav>
      {monthCount > 0 && (
        <button type="button" style={cardStyle} onClick={onOpenMonth}>
          {monthCount} {monthCount === 1 ? 'event' : 'events'} this month
        </button>
      )}
    </aside>
  );
}

export default AdminSidebar;